import { render } from "./unusedCoupon.vue?vue&type=template&id=5c133ac7"
import script from "./unusedCoupon.vue?vue&type=script&lang=js"
export * from "./unusedCoupon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__